import * as angular from "angular";
import {IController} from "angular";

export class agreementsTableCtrl implements IController {
  agreements: any;

  constructor() {
  }


}

angular
  .module('bringoz.admin.agreements')
  .component('agreementsTable', {
    bindings: {
      agreements: '<'
    },
    template: require('./agreements-table.html').default,
    controller: agreementsTableCtrl
  });
